export default "__VITE_ASSET__BmTpG$qa__"